import Paragraph from 'antd/lib/typography/Paragraph';
import styled from 'styled-components';

export const MessageParagraph = styled(Paragraph)`
  &&& {
    margin-bottom: 2px;
  }
`;
